import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import * as React from "react";
import Notices from "../../Notices/Notices";
import NoticesFilter from "../../Notices/NoticesFilter";

const TruckersReport = (props) => {
  return (
    <>
      <Typography variant="h5" sx={{ mb: 1, textAlign: "center", mt: 2 }}>
        Trucker Announcements
      </Typography>
      <Box sx={{ p: 1 }}>
        <MyNotices />
      </Box>
    </>
  );
};

const MyNotices = (props) => {
  const [location, setLocation] = React.useState(null);
  const endpoint = "/truckerAnnouncements.json";
  const parentModule = { endpoint: endpoint };

  return (
    <>
      <Typography variant="body1" sx={{ mb: 2 }}>
        The following announcements are specific to the trucking community. To
        see a complete list of all construction announcements, please visit{" "}
        <a href="/Notices/Construction" className="reportCell">
          Construction Announcements
        </a>
        .
      </Typography>
      <Box sx={{ p: 2, flexGrow: 1, width: "100%", flex: "1 0" }}>
        <NoticesFilter setLocation={setLocation} location={location} />
      </Box>
      <Box>
        <Notices
          location={location}
          parentModule={parentModule}
          module={module}
        />
      </Box>
    </>
  );
};

const module = {
  routeProps: {
    path: "TruckerAnnouncements",
    component: TruckersReport,
  },

  name: "Trucker Announcements",
  label: "Announcements",
  title: "Trucker Announcements",
  showOnMenu: true,
};

export default module;
